import React from "react";
import { Box, Typography, Container } from "@mui/material";

function PrivacyPolicy() {
  const DARK_NAVY = "#0A192F";
  const LIGHT_GRAY = "#B0BEC5";

  return (
    <Box
      sx={{
        minHeight: "100vh",
        py: { xs: 6, md: 10 },
        backgroundColor: DARK_NAVY,
        color: "white",
      }}
    >
      <Container maxWidth="md">
        <Typography variant="h4" gutterBottom sx={{ textAlign: "center" }}>
          Privacy Policy
        </Typography>

        <Typography
          variant="body1"
          sx={{ color: LIGHT_GRAY, mb: 4, textAlign: "center" }}
        >
          This Privacy Policy outlines how Arocoiris Technology Private Limited
          (“we”, “our”, “us”) collects, uses, stores, and protects your
          information in accordance with the Information Technology Act, 2000
          and the Information Technology (Reasonable Security Practices and
          Procedures and Sensitive Personal Data or Information) Rules, 2011.
        </Typography>

        <Section title="Information We Collect" color={LIGHT_GRAY}>
          We may collect the following information:
          <br />• Personal Information (name, email, phone)
          <br />• Usage Data (IP address, browser type, device information)
          <br />• Cookies and tracking data
        </Section>

        <Section title=" How We Use Your Information" color={LIGHT_GRAY}>
          We use your information to:
          <br />• Provide and improve our services
          <br />• Communicate updates and notifications
          <br />• Ensure platform security and fraud prevention
        </Section>

        <Section title=" Data Protection & Security" color={LIGHT_GRAY}>
          We follow ISO/IEC 27001‑aligned security practices as required under
          Indian IT Rules. We implement encryption, access controls, and secure
          storage to protect your data.
        </Section>

        <Section title=" Sharing of Information" color={LIGHT_GRAY}>
          We do not sell your data. Information may be shared only with:
          <br />• Service providers under confidentiality agreements
          <br />• Law enforcement when legally required
        </Section>

        <Section title=" Your Rights" color={LIGHT_GRAY}>
          Under Indian law, you have the right to:
          <br />• Access your data
          <br />• Request correction or deletion
          <br />• Withdraw consent
        </Section>

        <Section title=" Contact Us" color={LIGHT_GRAY}>
          For any privacy‑related concerns, contact:
          <br />
          Email: support@arocoristechnology.com
        </Section>
      </Container>
    </Box>
  );
}

function Section({ title, children, color }) {
  return (
    <Box sx={{ mb: 4 }}>
      <Typography variant="h6" sx={{ color: "white", mb: 1 }}>
        {title}
      </Typography>
      <Typography variant="body1" sx={{ color }}>
        {children}
      </Typography>
    </Box>
  );
}

export default PrivacyPolicy;
